import { Injectable } from '@angular/core';

const LOCAL_STORAGE_PREFIX = 'lf_shelf_';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  protected getFullKey(keySuffix: string) {
    return LOCAL_STORAGE_PREFIX + keySuffix;
  }

  save(keyName: string, data: any): void {
    localStorage.setItem(this.getFullKey(keyName), JSON.stringify(data));
  }

  get<T>(keyName: string): T | null {
    const data = localStorage.getItem(this.getFullKey(keyName));

    return data ? (JSON.parse(data) as T) : null;
  }

  delete(keyName: string): void {
    localStorage.removeItem(this.getFullKey(keyName));
  }
}
